import Vue from "vue";

import buttonScComponent from "@/components/child/form/buttonSc.vue";
import dateTimePickerComponent from "@/components/child/form/datetimepicker.vue";
import moedaComponent from "@/components/child/form/moeda.vue";
import textareaComponent from "@/components/child/form/textarea.vue";
import { Component } from "@/decorators";
import ContaReceberModel from "@/models/financeiro/contaReceberModel";

import GerarBoletoComponent from "./gerarBoleto";
import gerarBoletoComponent from "./gerarBoleto.vue";

import "../../crud/crud.scss";

@Component({
    components: {
        textareaComponent,
        moedaComponent,
        dateTimePickerComponent,
        buttonScComponent,
        gerarBoletoComponent,
    },
})
export default class ParcelaComponent extends Vue {
    private gerarBoletoComponent: GerarBoletoComponent = null;

    public model = new ContaReceberModel();

    private clear() {
        this.model = new ContaReceberModel();
        this.model.contabilizar = false;
        this.model.dataLancamento = new Date();
        this.$validator.reset();
    }

    public async loadLinkBoleto() {
        this.gerarBoletoComponent = this.$refs.gerarBoletoComponent as GerarBoletoComponent;

        await this.gerarBoletoComponent.loadLinkBoleto(this.model);
    }

    public load(saldo: number, desconto: number) {
        this.clear();

        this.model.valorTotal = 0;
        if (saldo > 0) {
            this.model.valorTotal = saldo;
        }
        this.model.totalDesconto = desconto;
    }

    private onChangeData() {
        if (this.model.observacao) {
            return this.$notifyWarn(this.$t("__.ts.dataVencimentoAlterada"));
        }
    }

    public async validate() {
        return await this.$validator.validateAll();
    }

    private mounted() {
        this.clear();
    }
}
